import { useOpen } from 'common/hooks';
import { Form, FormItem, Button, Modal, ButtonLink, Box, Text } from 'common/components';
import { Input } from 'antd';
import { FIELD_RULES } from 'common/constants';
import { usePushbackDrawdown } from '../api';
import commonStyles from '../styles.module.scss'

interface RequestDeclineProps {
  projectUuid: string
  drawdownUuid: string
  disabled?: boolean
}

const { TextArea } = Input;

export default function PushbackModal({
  projectUuid,
  drawdownUuid,
  disabled,
}: RequestDeclineProps) {
  const [isOpen, handleOpen, handleClose] = useOpen();

  const { mutate: pushbackRequest, isMutating } =
  usePushbackDrawdown(projectUuid, drawdownUuid, handleClose);

  const handleFinish = (reason: any) => pushbackRequest(reason);

  return (
    <>
      <Box align="center" mt={12} className={commonStyles.pushbackContent}>
        <ButtonLink
          danger
          className={commonStyles.pushbackButton}
          disabled={disabled}
          onClick={handleOpen}
        >
          push back
        </ButtonLink>{' '}
        <Text color="grey" size="xs" weight="medium" as="span">
          to Lending Manager
        </Text>
      </Box>
      <Modal
        width={486}
        title="Back to Lending Manager"
        open={isOpen}
        onCancel={handleClose}
      >
        <Form onFinish={handleFinish}>
          <FormItem name="reason" label="Description" rules={FIELD_RULES}>
            <TextArea rows={7} maxLength={1024} />
          </FormItem>
          <Button block htmlType="submit" loading={isMutating}>
            Save reason
          </Button>
        </Form>
      </Modal>
    </>
  )
}
